<div class="main-motd">{{'MOTD_CONTENT' | translate}}</div>
<div class="grid" style="text-align: center;color: #FFA500;">
  <div class="col-12" style="font-size: 2em;">
      Veuillez cliquer sur le lien de téléchargement pour récupérer votre courrier :
  </div>
  <div class="col-12" (click)="download()">
    <i style="font-size: 10em;cursor: pointer;" class="fa fa-cloud-download"></i>
  </div>
</div>






